import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
// import CompanyIcon from '@mui/icons-material/Business';

import { CompaniesTableContainer } from '../../components/companies';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchCompanies, fetchManufacturers, fetchLogistics } from '../../actions/adminActions';

import './admin.scss';

const CompaniesPage = ({ companies, fetchCompanies, fetchManufacturers, fetchLogistics, manufacturers, logistics }) => {
  useEffect(() => {
    fetchCompanies();
    fetchManufacturers();
    fetchLogistics();
  }, [fetchCompanies, fetchManufacturers, fetchLogistics]);

  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title="Total Companies" number={companies?.length} icon={<CompanyIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title="Active Companies" number={companies?.filter((c) => !!c.active)?.length}*/}
      {/*              icon={<CompanyIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title="Total Companies" number={companies?.length} icon={<CompanyIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}

      <Box sx={{ width: '100%' }}>
        <CompaniesTableContainer
          companies={companies}
          withButton
          manufacturers={manufacturers}
          logistics={logistics}
        />
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  companies: state.companies.list,
  manufacturers: state.manufacturers.list,
  logistics: state.logistics.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCompanies: () => dispatch(fetchCompanies()),
  fetchManufacturers: () => dispatch(fetchManufacturers()),
  fetchLogistics: () => dispatch(fetchLogistics()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompaniesPage);
